import { Component } from '@angular/core';

// common
import { TaggedItemLibrary, ITagMap, IAdviceSet } from '@aa/common';

// shared
import { QnaStage } from '@aa/selfserv/shared';

// qna
import { AbstractQnaComponent } from '../abstract-qna.component';
import { QnaNavigationService } from '../qna-navigation.service';


@Component({
  selector: 'aa-qna-advice-index',
  templateUrl: './advice-index.component.html',
  styleUrls: ['./index.component.scss']
})
export class QnaAdviceIndexComponent extends AbstractQnaComponent {

  public readonly adviceSetLibrary: TaggedItemLibrary<IAdviceSet>;

  constructor(navigation: QnaNavigationService) {
    super(navigation, 'Advice Index', QnaStage.Advice);

    const tagMap: ITagMap = this.data;
    this.adviceSetLibrary = new TaggedItemLibrary(this.data.adviceSets, tagMap, o => o.name);
  }
}
